import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { APP_VERSION } from './constants';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['pt', 'en', 'fr', 'es', 'it', 'de', 'ja', 'zh', 'ru', 'hu'],
    preload: ['en'], // Preload English to ensure it's always available as a fallback
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    returnEmptyString: false,
    returnNull: false,
    backend: {
      loadPath: `/locales/{{lng}}/translation.json?v=${APP_VERSION}`,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    // Global fallback for missing keys to prevent "key.path.name" from appearing
    // by default i18next handles fallbacks correctly.
  });

export default i18n;
